import React, { Fragment, useContext, useState,useEffect } from "react";
import "../../../../../ui-styles/sliders/RightFullSlider.css";
import "../../../../../ui-styles/profile/SlideProfileDetails.css";
import { LangCtx } from "../../../../../lib/context";
import { dateFormat, getAge } from "../../../../../lib/functions";
import {addrLangObj} from "../../../../../locale/address/index";
import { Tab, Tabs } from "@material-ui/core";
import { updatedoctor } from "../../../../../actions/users";
import CertificationsTab from "./CertificationsTab";
import Button from "../../../../../ui-styles/controls/button";
import Loader from "../../../../../lib/ui/loader/Loader";
import { toast } from "react-toastify"; 
// import { capitalize } from "@material-ui/core";
import Rating from '@material-ui/lab/Rating';


const DocProfileSlide = (props) => {
    const [value, setValue] = useState(0);
    const { l } = useContext(LangCtx);
    const al = addrLangObj[l.locale];
    const { data, setUploadView, setDoctors } = props;
    console.log("slide_data", data)
    const [status, setStatus] = useState(data.status || ""); 
    const [loading, setLoading] = useState(false);
    const [certifications, setCertifications] = useState({
        medicaldocuments: { title: "Medical Certifications", data: [] },
        provisionaldocuments: { title: "Provisional Certificates", data: [] },
    });

    useEffect(() => {
        setCertifications({
            medicaldocuments: {
                title: "Medical Certifications",
                data: data.medicaldocuments || [],
            },
            provisionaldocuments: {
                title: "Provisional Certificates",
                data: data.provisionaldocuments || [],
            },
        });
        // setActions(
        //     certifications.reduce((acc, cert) => {
        //         acc[cert.id] = cert.status === "Approved" ? "accepted" : cert.status === "Rejected" ? "declinedSent" : null;
        //         return acc;
        //     }, {})
        // );
    }, [data]);

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };


    const areCertificatesApproved = () => {
        const combinedCertificates = [
            ...certifications.medicaldocuments.data,
            ...certifications.provisionaldocuments.data,
        ];
    
        if (combinedCertificates.length > 0) {
          const allApproved = combinedCertificates.every(
            (cert) => cert.status === "approved"
          );
          return allApproved;
        }
        return true;
      };
    
      const handleUpdateStatus = async (newStatus) => {
        if (newStatus === "approved" && !areCertificatesApproved()) {
          toast.error("All certificates must be approved ");
          return;
        }
    
        setLoading(true);
        try {
          const body = { status: newStatus };
          await updatedoctor(data.userId, body, "doctor");
          setDoctors((prevDoctors) =>
            prevDoctors.map((doctor) =>
              doctor.userId === data.userId ? { ...doctor, status: newStatus } : doctor
            )
          );
          setStatus(newStatus);
          console.log(`${newStatus} status updated successfully`);
          toast.success(`Doctor ${newStatus} successfully.`);
        } catch (error) {
          console.error("Error updating doctor status:", error);
          toast.error("All certificates must be approved before approving the doctor.");
        } finally {
          setLoading(false);
        }
      };

    const handleFileView = (data) => {
        setUploadView(data)
    }
    console.log(handleFileView,"KKKKKKKKKKst")

    return (
        <div className={props.open ? "rightFullSlider rightSliderIn" : "rightFullSlider"}>
             {loading && <Loader />}
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>{l.profile}</span>
                    </div>
                    <div className="hdrActionGroup">
                        <div className="hdrActItem close" onClick={props.closeSlide}></div>
                    </div>
                </div>
            </div>
            <div className="rightSliderBdy">
                <div className="profileContainer">
                    <div className="profileTopClinic">
                        <div className="profileAvtr">
                            {data && data.profileImage && data.profileImage.url !=='' ?
                                <img src={data.profileImage.url} alt="avatar" />
                                :
                                <div className="roundimg">{data.firstName.charAt(0)}</div>
                            }
                        </div>
                        <h2 className="profileTxtL">{data.title ? data.title : ''} {data.firstName ? data.firstName : ''}</h2>
                        <span><Rating name="read-only" precision={0.1} value={data.ratings?.stars || 0}readOnly /></span>
                        
                        <span className="profileTxtS">{data.department ? data.department : ''}</span>
                        <span className="profileTxtS">{data.speciality ? data.speciality : ''}</span>
                        <div  className='alignCenter pdngTXS' >
                        <div className='alignCenter pdngTXS'>
                            <Button
                                text={status === "approved" ? "Approved" : "Approve"}
                                variant="contained"
                                size="small"
                                className="mrgRight8"
                                style={{
                                    color: status === "approved" ? "#FFFFFF" : "#1B6F14",
                                    border: status === "approved" ? "none" : "2px solid #1B6F14",
                                    backgroundColor: status === "approved" ? "#1B6F14" : "#1B6F141A",
                                }}
                                onClick={() => handleUpdateStatus("approved")}
                                disabled={loading || status === "approved"}
                            />

                            <Button
                                text={status === "rejected" ? "Rejected" : "Reject"}
                                variant="contained"
                                size="small"
                                style={{
                                    color: status === "rejected" ? "#FFFFFF" : "#FD8D8D",
                                    border: status === "rejected" ? "none" : "2px solid #FD8D8D",
                                    backgroundColor: status === "rejected" ? "#FD8D8D" : "#FD8D8D1A",
                                }}
                                onClick={() => handleUpdateStatus("rejected")}
                                disabled={loading || status === "rejected"}
                            />
                        </div>


                        </div>
                        <div className="flexCol fullWidth" >
                        <Tabs
                            value={value}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={handleTabChange}
                        >
                            <Tab label="Info" style={{ textTransform: "none" }} />
                            <Tab label="Certifications" style={{ textTransform: "none" }} />
                        </Tabs>
                       
                          
                       
                        {value === 1 && (
                            <div>
                               <CertificationsTab userData={data} certifications={certifications} setCertifications={setCertifications} handleFileView={handleFileView}/>
                            </div>
                        )}
                        </div>
                    </div>
                    {value === 0 && (
                    <div className="profileDetailsClinic">
                        <div className="profileDtlGroup">
                            {/* <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.civil_number}:<small>{data.civilNumber ? data.civilNumber : ''}</small></span>
                            </div> */}
                             <div className="profileDtlHdr">
                            <span className="profileDtlTxt">Details</span>
                        </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.pat_gender}<small className="capitalizeTxt">{data.gender ? data.gender : ''}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_dob}<small>{data.dob ? dateFormat(data.dob) : ''}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_age}<small>{data.dob ? getAge(new Date(data.dob)) : ''}</small></span>
                            </div>
                        </div>
                        <div className="profileDtlHdr">
                            <span className="profileDtlTxt">{l.med_det}</span>
                        </div>
                        {data.licenses ? data.licenses.map((license, i) => <Fragment key={license.license}>
                                <div className="profileMedLicHdr">
                                    <span className="profileDtlTxt">{l.label_licen} {i + 1}</span>
                                </div>
                                <div className="profileDtlGroup">
                                    <div className="profielDtlItem">
                                        <span className="profileDtlTxt">{l.label_licen}:<small>{license.license}</small></span>
                                    </div>
                                    <div className="profielDtlItem">
                                        <span className="profileDtlTxt">{l.lic_no}:<small>{license.licenseNo}</small></span>
                                    </div>
                                    <div className="profielDtlItem">
                                        <span className="profileDtlTxt">{l.exp_date}:<small>{dateFormat(license.expirationDate)}</small></span>
                                    </div>
                                    <div className="profielDtlItem">
                                        <span className="profileDtlTxt">{l.label_country}<small>{data.country && data.country !== '' ? al[data.country] : '--'}</small></span>
                                    </div>
                                </div>
                            </Fragment>
                        ) : <div className="profielDtlItem"> <span className="profileDtlTxt">No licenses</span></div>
                        }
                        <div className="profileDtlHdr">
                            <span className="profileDtlTxt">{l.contact_details}</span>
                        </div>
                        <div className="profileDtlGroup">
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_email}<small>{data.email && data.email !== '' ? data.email : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_phone_no}<small>{data.countryCode? `+${data.countryCode} `:''}{data.phone? data.phone: '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.alt_phone_no}<small>{data.alternatePhone && data.alternatePhone !== '' ? data.alternatePhone : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_address}<small>{data.address && data.address !== '' ? data.address : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_city}<small>{data.city && data.city !== '' ? al[data.city] : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_state}<small>{data.stateName && data.stateName !== '' ? al[data.stateName] : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_country}<small>{data.country && data.country !== '' ? al[data.country] : '--'}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_pin}<small>{data.pincode && data.pincode !== '' ? data.pincode : '--'}</small></span>
                            </div>
                        </div>
                    </div>
                     )}
                </div>
            </div>
        </div>
    )
}

export default DocProfileSlide;